/* eslint-disable react/button-has-type */
import React from 'react'
import PropTypes from 'prop-types'
import { buttonThemes } from '~helpers/content'
import classNames from 'classnames'

class Button extends React.Component {
  render () {
    const { className, children, theme, type, busy, ...props } = this.props

    return (
      <button
        className={classNames(
          'transition-colors relative duration-200 ease-in-out py-4 px-6 inline-flex items-center border outline-none text-center appearance-none justify-center',
          buttonThemes[theme || 'primary'],
          { 'opacity-50 pointer-events-none': props.disabled },
          { 'pointer-events-none': props.busy },
          className
        )}
        type={type || 'button'}
        onClick={this.props.onClick}
        {...props}
      >
        {busy && (
          <span className="animate-progress pointer-events-none w-0 h-full absolute top-0 left-0 bg-charcoal bg-opacity-40" aria-hidden="true" />
        )}

        <span className="relative z-10">
          {children}
        </span>
      </button>
    )
  }
}

Button.propTypes = {
  children: PropTypes.any,
  onClick: PropTypes.func,
  type: PropTypes.string,
  theme: PropTypes.string,
  status: PropTypes.string,
  busy: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string
}

export default Button
